module.exports = __webpack_public_path__ + "img/banner_h501.b6a88830.webp";